import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import error404 from '../components/error404.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/404',
        name: 'error404',
        component: error404,
        meta: {
            auth: false,
        },
    },
    {
        path: '/:referral_hash?',
        name: 'Home',
        component: Home,
        props: (route) => ({
            // Важно: предотвращаем передачу '404' как referral_hash
            referral_hash: route.params.referral_hash === '404' ? null : route.params.referral_hash
        }),
        meta: {
            auth: false,
        },
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export default router